import React,{useState, useEffect, useMemo} from 'react';
import Select from 'react-select';
import { SECUNDARY_COLOR } from '../../constants/colors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from "@fortawesome/free-solid-svg-icons";

//propToChange se utiliza al momento de setear la propiedad de un componente el cual utiliza mas de un SelectControl y utiliza un solo handleChange para modificar sus propiedades.
function SelectControl({modo, disabled=false,  handleChengeSelect, idSelect = '', optionsSelect, data = {label:'', value:''}, setData = () => console.log("setData"), setShowAdd = () => console.log("showAdd"), valueSeleccionada,  placeholder, setNuevoEditado, tipo = '', index = 0, setIndexToUpdate = () => console.log("setIndexFromTareasSubTabla"), propToChange = '', componentePadre='', style={}}){

const [state, setState] = useState();

const flagPropsActivo = useMemo(()=>['activoType','solicitaLecturaODT','nivel1','nivel2','nivel3','nivel4','nivel5'].includes(tipo), [tipo]);

    useEffect(() => {
        if(valueSeleccionada?.value !== "") {
            setState({...valueSeleccionada});
        }else{ 
            //Else agregado recientemente ya que nunca se volvia el Select a vacio al eliminarlos en Tareas x Mantenimientos.
            if((['solicitaLecturaODT', 'tareaMant', 'logUbicaciones', 'procedimientoXactivo', 'logsFServ', 'lecturas', 'procsProgramados', 'documentos', 'fichaTecnica', 'tareaOT', 'tareaTemplate', 'peligroOT', 'eppOT', 'herramientaOT', 'eqpgOT', 'categoriaRRHH', 'imputacionRRHH', 'proveedor', 'checkList', "selectActivo", 'logUbicaciones', 'odtToAssociate'].includes(tipo) || flagPropsActivo) && valueSeleccionada?.value == ''){
                setState(valueSeleccionada);
            } 
        }
        if(valueSeleccionada?.value === undefined) {
            if(valueSeleccionada?.name !== undefined) {
                //If necesario ya que las tareas de procedimiento ya creado deben setear label con la propiedad descrp, en caso de procedimiento nuevo con name
                (tipo === 'tareaMant' || tipo === 'checkList') ? setState({...valueSeleccionada, value: valueSeleccionada?.name, label:valueSeleccionada?.descrp}) : setState({...valueSeleccionada, value: valueSeleccionada?.name, label:valueSeleccionada?.name})
            }else{
                if(valueSeleccionada?.nameNivel3 !== undefined){
                    setState({...valueSeleccionada, value: valueSeleccionada?.nameNivel3, label:valueSeleccionada?.nameNivel3})
                }else{
                     if(valueSeleccionada?.nameTypeActivo !== undefined){
                        setState({...valueSeleccionada, value: valueSeleccionada?.nameTypeActivo, label:valueSeleccionada?.nameTypeActivo})
                    }
                }
            }
        }
    },[valueSeleccionada]);

    const typesToAvoidAddButton = ['solicitaLecturaODT', 'procedimientoXactivo','logUbicacionesUser','controlOT','selectActivo','logsFServ','lecturas', 'procsProgramados', 'modalProcedimientoXActivo', 'categoriaRRHH', 'imputacionRRHH', 'proveedor', 'getTareasByProc', 'getTareasByTemplate', 'odtToAssociate'];
    const typesToAvoidEditButton = ['solicitaLecturaODT', 'procedimientoXactivo','logUbicacionesUser','controlOT','selectActivo','logsFServ','lecturas', 'procsProgramados', 'modalProcedimientoXActivo', 'categoriaRRHH', 'imputacionRRHH', 'proveedor', 'getTareasByProc', 'getTareasByTemplate', 'odtToAssociate'];

    return (
    <div className='selectControlDiv' style={{ flex: 1, display: "flex", marginRight: ".5rem", ...style }}>
        <div className='selectControlChildDiv' style={{ flex: 1, marginRight: ".5rem" }}>
                {
                    (modo === "Vista") && (
                        <CustomSelect
                            propToChange={propToChange}
                            disabled={modo === 'Vista' || tipo == 'controlOT' || componentePadre == 'StateChange' || disabled} 
                            placeholder={placeholder}
                            options={optionsSelect}
                            value={state}
                            onChange={(selectedOption) => handleChengeSelect(selectedOption)}
                        />
                    )
                }
                {
                    (modo === 'Edicion' || modo === "Copia" || modo === 'Nuevo') && (
                        <CustomSelect
                            placeholder={
                                (modo === 'Edicion' || modo === "Copia") ? (state?.value ? state?.value :  placeholder ) :  placeholder
                            }
                            propToChange={propToChange}
                            options={optionsSelect}
                            value={state}

                            disabled={tipo == 'controlOT' || disabled} 
                            onChange={(selectedOption) => {
                                if(['tareaMant','procedimientoXactivo', 'tareaOT', 'tareaTemplate', 'peligroOT', 'eppOT', 'herramientaOT', 'eqpgOT', 'checkList', 'odtToAssociate'].includes(tipo)) handleChengeSelect(selectedOption,index)
                                else if(['logUbicaciones', 'logsFServ', 'logUbicacionesUser'].includes(tipo)) handleChengeSelect({},index,propToChange,selectedOption)
                                else if(['lecturas', 'procsProgramados', 'documentos', 'categoriaRRHH', 'imputacionRRHH', 'proveedor', 'checklist','fichaTecnica'].includes(tipo)) handleChengeSelect({},index,propToChange,selectedOption)
                                else if(flagPropsActivo) handleChengeSelect({},tipo,selectedOption)
                                else if(['documentos', 'selectActivo'].includes(tipo)) setData(selectedOption)
                                else if(tipo == 'modalProcedimientoXActivo') handleChengeSelect(selectedOption,'proc');
                                else handleChengeSelect(selectedOption, state);
                            }}
                        />
                    )
                }
        </div>

        {
            //!! signos que al posarse encima muestra la descripción de la tarea o checklist. 
            (idSelect == 'tarea' && state?.showDescrp && state?.label) ? <label title={state?.descrp ?? ''} style={{alignSelf:'center', marginRight:8, color:'blue', fontWeight:500, fontSize:32}}>!!</label> : ''
        }
        
        {   
            //Renderizado condicional de boton + para agregar registros.
            (!typesToAvoidAddButton.includes(tipo)  && (tipo == 'logUbicaciones' && data.label != '' || tipo == 'logUbicaciones' && propToChange == 'nivel1' || tipo != 'logUbicaciones')) && modo !== "Vista" && 
            <button className='button-add-form' style={{ backgroundColor: SECUNDARY_COLOR }} onClick={() => ((tipo == 'logUbicaciones') ? setShowAdd(propToChange) : (flagPropsActivo) ? setShowAdd(tipo) : setShowAdd(true), setNuevoEditado("Agregar"), modo !== "Nuevo" ? (setData({...valueSeleccionada, value: '',label:'', id: '', nameTypeActivo: '', descrp: '', name: '', codNivel1:'', codNivel2:'', codTypeActivo:'',nameNivel3:'', codNivel3:'', codNivel4: '', codNivel5:''})) : setData(""))}>
                +
            </button>
        }

        {
            //Renderizado condicional de Lapiz para editar registros.
            (!typesToAvoidEditButton.includes(tipo)) && modo !== "Vista" && (valueSeleccionada && valueSeleccionada.label != "") && (valueSeleccionada && 
            <button className='button-add-form' style={{ backgroundColor: 'green', marginLeft:'5px' }} onClick={() => ((tipo == 'logUbicaciones') ? setShowAdd(propToChange) : (flagPropsActivo) ? setShowAdd(tipo) : setShowAdd(true), setIndexToUpdate(index), setNuevoEditado("Modificar"), setData(valueSeleccionada))}>
                <FontAwesomeIcon icon={faPen}/>
            </button>
            )
        }

    </div>
  )
}

function CustomSelect ({
    modo,
    options,
    value,
    onChange,
    placeholder,
    disabled,
    propToChange
  }) {
    return (
       <Select
       menuPortalTarget={document.body} // renders menu at the document root
       menuPosition="fixed"              // ensures proper positioning
        styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            input: (base) => ({
                ...base,
                // width: propToChange == 'solicitaLecturaODT' ? '100%' : '60%',                
                width: '60%',
                padding: '.4rem',
                borderRadius: '.5rem',
                fontSize: '1rem',
                transition: 'border-color .5s',
                boxShadow: 'none !important',
            }),
            option: (base) => ({
                ...base
            }),
            singleValue: (base) => ({
                ...base,
                textAlign: propToChange == 'solicitaLecturaODT' ? 'center' : 'default',
                fontWeight: (propToChange == 'codProc') && 'bold'
            })
        }}
        className='selectControl'
        isDisabled={disabled}
        options={options}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        />
    );
}

export default SelectControl;

